import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-investigator-tab',
  templateUrl: './ui-investigator-tab.component.html',
  styleUrls: ['./ui-investigator-tab.component.scss']
})
export class UiInvestigatorTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
